module.exports = __webpack_public_path__ + "static/media/sidebar.f5288fa0.webp";